<div *ngIf="invoices != null">
    <ng-container *ngFor="let invoice of invoices; let i = index" [attr.data-index]="i">
        <div [hidden]="!showItem(invoice.statusStatement, invoice.storeName) " class="card">
            <div class="card-content" (click)="showDetails(invoice,$event)">
                <div class="row">
                    <div class="col-xs-12">
                        <button *ngIf="invoice.invoiceUrl == null" class="btn btn-xs  btn-danger"
                            style="float:right; width: 60px">
                            s/ fatura </button>
                        <a *ngIf="invoice.invoiceUrl != null" [href]="invoice.invoiceUrl" target="_blank"
                            class="btn btn-xs btn-success" style="float:right; width: 60px">fatura</a>
                        <div class="numbers" style="text-align: left; font-size: 20px">
                            <p>{{ invoice.date | date:'MM/yy'}}</p>
                            {{ invoice.storeName}}
                        </div>

                        <div class="text-center">
                            <div class="row">
                                <div class="col-md-6">
                                    <h5>
                                        <small>Polen</small>
                                        <br>
                                        <span *ngIf="invoice.planSeoName != 'percentual'">R${{
                                            invoice.polenSubscription -
                                            invoice.discount | number:'1.2-2'}}</span>
                                        <span *ngIf="invoice.planSeoName == 'percentual'">R${{ invoice.totalCommission
                                            |
                                            number:'1.2-2'}}</span>
                                    </h5>
                                </div>
                                <div class="col-md-6 ">
                                    <h5>
                                        <small>Doação</small>
                                        <br>
                                        <span *ngIf="invoice.ngos == null" class="ti-na"></span>
                                        <span *ngIf="invoice.planSeoName != 'percentual' && invoice.ngos != null">R${{
                                            invoice.totalDonationApproved | number:'1.2-2'}}</span>
                                        <span
                                            *ngIf="invoice.planSeoName == 'percentual' && invoice.ngos != null">R${{
                                            invoice.totalDonationApproved - invoice.totalCommission | number:'1.2-2'}}</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ngx-smart-modal #invoiceModal identifier="invoiceModal" customClass="small-modal">
        <div>
            <h4 class="card-title">{{ invoiceEdit.date | date:'MM/yy'}} - {{ invoiceEdit.storeName}}</h4>
            <table class="table table-striped">
                <tbody>
                    <tr>
                        <td>Data</td>
                        <td>
                            {{ invoiceEdit.date | date:'dd/MM/yy' : 'UTC 0'}}
                            &nbsp;(De: {{ invoiceEdit.fromDate | date:'dd/MM/yy' : 'UTC 0'}} até {{ invoiceEdit.toDate |
                            date:'dd/MM/yy' : 'UTC 0'}})
                        </td>
                    </tr>
                    <tr>
                        <td>Plano</td>
                        <td>{{ invoiceEdit.planSeoName}}</td>
                    </tr>
                    <tr>
                        <td>Valor da Fatura</td>
                        <td>
                            <div>R${{ invoiceEdit.totalDonationApproved + invoiceEdit.polenSubscription -
                                invoiceEdit.discount |
                                number:'1.2-2'}}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>Mensalidade</td>
                        <td>
                            <div *ngIf="invoiceEdit.planSeoName != 'percentual'">R${{ invoiceEdit.polenSubscription |
                                number:'1.2-2'}}</div>
                            <div *ngIf="invoiceEdit.planSeoName == 'percentual'">R${{ invoiceEdit.totalCommission |
                                number:'1.2-2'}}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>Doação</td>
                        <td>
                            <div *ngIf="invoiceEdit.ngos == null">Sem doação nesta fatura</div>
                            <div *ngIf="invoiceEdit.planSeoName != 'percentual' && invoiceEdit.ngos != null">
                                R${{ invoiceEdit.totalDonationApproved | number:'1.2-2'}}</div>
                            <div *ngIf="invoiceEdit.planSeoName == 'percentual' && invoiceEdit.ngos != null">
                                R${{ invoiceEdit.totalDonationApproved - invoiceEdit.totalCommission | number:'1.2-2'}}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Ongs</td>
                        <td>
                            <div *ngIf="invoiceEdit.ngos == null">Sem Ongs apoiadas nesta fatura</div>
                            <div *ngIf="invoiceEdit.ngos != null">
                                <table class="table table-striped">
                                    <tbody>
                                        <tr *ngFor="let ngo of invoiceEdit.ngos">
                                            <td>{{ ngo.ngoName}}</td>
                                            <td *ngIf="invoiceEdit.planSeoName == 'percentual'">{{
                                                ngo.commissionPercentage |
                                                number:'1.2-2'}} - R$ {{ (ngo.donation * ngo.commissionPercentage) |
                                                number:'1.2-2'}} (R${{
                                                ngo.donation | number:'1.2-2'}})</td>
                                            <td *ngIf="invoiceEdit.planSeoName != 'percentual'">R$ {{ ngo.donation |
                                                number:'1.2-2'}}</td>
                                            <td>
                                                <div *ngIf=" ngo.statusStatement == 7" (click)="filterStatement('paid')"
                                                    class="pull-left"><span class="label label-warning"> Aguardando
                                                        Saque </span></div>
                                                <div *ngIf=" ngo.statusStatement == 3" (click)="filterStatement('paid')"
                                                    class="pull-left"><span class="label label-success"> Depositado
                                                    </span></div>
                                                <div class="label label-default">Status ({{ ngo.statusStatement}})</div>
                                                <div class="label label-success" *ngIf="ngo.commissionSaleId != null">
                                                    Associado</div>
                                                <a *ngIf="invoiceEdit.depositReceipt != null"
                                                    [href]="invoiceEdit.depositReceipt" target="_blank"
                                                    class="btn btn-xs btn-success btn-wd">Ver
                                                    Comprovante</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Referente à doações</td>
                        <td>
                            De {{ invoiceEdit.fromDate | date:'dd/MM/yy' : 'UTC 0'}} até {{ invoiceEdit.toDate |
                            date:'dd/MM/yy' : 'UTC 0'}}
                        </td>
                    </tr>
                    <tr>
                        <td>Iugu</td>
                        <td>
                            <form name="form" (ngSubmit)="f.form.valid" #f="ngForm" novalidate>
                                <div class="form-group">
                                    Id Iugu:
                                    <input class="form-control" type="text" name="invoiceId"
                                        [(ngModel)]="invoiceEdit.invoiceId" #invoiceId="ngModel" class="form-control" />
                                    <br>
                                    Link Fatura:
                                    <input class="form-control" type="text" placeholder="url da fatura"
                                        name="invoiceUrl" [(ngModel)]="invoiceEdit.invoiceUrl" #invoiceUrl="ngModel"
                                        class="form-control" />
                                    &nbsp; <a *ngIf="invoiceEdit.invoiceUrl != null" [href]="invoiceEdit.invoiceUrl"
                                        target="_blank" class="btn btn-xs btn-success btn-wd">Ver fatura</a>
                                    <br>
                                    Data de Vencimento:
                                    <input class="form-control" type="text" placeholder="dd/mm/yyyy" name="invoiceDate"
                                        [(ngModel)]="invoiceEdit.invoiceDate" #invoiceDate="ngModel"
                                        class="form-control" />
                                    <br>
                                    Data oficial deste Statement:
                                    <input class="form-control" type="text" placeholder="dd/mm/yyyy" name="invoiceDate"
                                        [(ngModel)]="invoiceEdit.date" #invoiceDate="ngModel" class="form-control" />
                                    <br>
                                    <label>Fatura enviada?</label>
                                    <br>
                                    <label class="switch">
                                        <input type="checkbox" name="invoiceSent" [checked]="invoiceEdit.invoiceSent"
                                            (change)="invoiceEdit.invoiceSent= !invoiceEdit.invoiceSent">
                                        <span class="slider round"></span>
                                    </label>
                                    <br>
                                    <div *ngIf="invoiceEdit.invoiceError == null">Erro: -</div>
                                    <div *ngIf="invoiceEdit.invoiceError != null">Erro: {{ invoiceEdit.invoiceError}}
                                    </div>
                                    <br>
                                    Status da Fatura:
                                    <select class="form-control" name="statusStatement"
                                        [(ngModel)]="invoiceEdit.statusStatement">
                                        <option [value]="1">Aguardando Pagamento</option>
                                        <option [value]="2">Loja Pagou</option>
                                        <option [value]="3">Doado Parcialmente</option>
                                        <option [value]="4">Doação Feita</option>
                                        <option [value]="5">Aguardando Dados das Ongs</option>
                                        <option [value]="10">Completado</option>
                                        <option [value]="11">Loja NÃO pagou</option>
                                        <option [value]="20">Problema no pagamento</option>
                                    </select>
                                    <br>
                                    <button class="btn btn-info btn-fill" type="button"
                                        (click)="updateStatementInvoice(invoiceEdit)">Atualizar
                                        Fatura</button>
                                </div>
                            </form>
                        </td>
                    </tr>
            </table>
        </div>
    </ngx-smart-modal>
</div>